// extracted by mini-css-extract-plugin
export default {"block":"PaginationSlider_block__PmfAY","bulletsPosition-right":"PaginationSlider_bulletsPosition-right__ySSCh","bulletsPosition-left":"PaginationSlider_bulletsPosition-left__bwfNO"};